import { ESTADOS_SOLICITUDES_INSCRIPCIONES } from './constantes';

export const cellRendererNumeroRegistro = (param) => {
  if (param.node.rowPinned) {
    return undefined;
  }

  return param.node.rowIndex + 1;
};

export const cellRendererSiONo = (llave, textoSi, textoNo) => {
  return (params) => {
    const estado = params.data[llave];
    const color = estado ? 'green' : 'red';

    return /*html*/ `
      <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
          <span class="v-chip__content"> ${estado ? textoSi : textoNo}</span>
      </span>
    `;
  };
};

export const cellRendererEstadoSolicitudInscripcion = (params) => {
  const estado = params.data?.estado?.toUpperCase();
  let color = 'default';

  if (estado == ESTADOS_SOLICITUDES_INSCRIPCIONES.PENDIENTE.toUpperCase()) {
    color = 'orange';
  } else if (estado == ESTADOS_SOLICITUDES_INSCRIPCIONES.APROBADA.toUpperCase()) {
    color = 'green';
  } else if (estado == ESTADOS_SOLICITUDES_INSCRIPCIONES.RECHAZADA.toUpperCase()) {
    color = 'red';
  }

  return /*html*/ `
    <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
        <span class="v-chip__content"> ${estado} </span>
    </span>
  `;
};

export const formatearErrores = (errores) => {
  if (typeof errores == 'string') {
    return errores;
  }

  let erroresFormateados = '';

  Object.keys(errores).forEach((key) => {
    const itemsErrores = errores[key].map((item) => `<li>${item}</li>`).join('');

    erroresFormateados += itemsErrores;
  });

  return erroresFormateados;
};

export const formatearValorAMoneda = (valor) => {
  valor = Number(valor).toFixed(2);

  return valor
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    .replace(/.([^.]*)$/, ',$1');
};

export const valueFormatterMoneda = (params) => {
  if (params.node.rowPinned) {
    return params.value;
  }

  return formatearValorAMoneda(params.value);
};

export const concatenar = (...args) => {
  return args.filter((arg) => arg).join(' ');
};

export const formatearFechaCadena = (fecha, separador = '/') => {
  if (!fecha) {
    return null;
  }

  const [año, mes, dia] = fecha.split('-');
  const fechaFormateada = `${dia}${separador}${mes}${separador}${año}`;

  return fechaFormateada;
};

export const obtenerInscripcionModuloMasAlto = (inscripcionesModulos) => {
  if (Array.isArray(inscripcionesModulos) && inscripcionesModulos.length > 0) {
    const inscripcionModuloMasAlto = inscripcionesModulos.reduce((max, actual) => {
      return actual.programaModulo?.numero > (max.programaModulo?.numero ?? -Infinity) ? actual : max;
    }, inscripcionesModulos[0]);

    return inscripcionModuloMasAlto;
  }

  return null;
};

export const imprimirProgramaModulo = (inscripcionModulo) => {
  if (!inscripcionModulo) {
    return '-';
  }

  const nombreModulo = inscripcionModulo.programaModulo?.modulo?.nombre;
  const numeroModulo = inscripcionModulo.programaModulo?.numero;

  return `N° ${numeroModulo.toString()} - ${nombreModulo}`;
};

export const obtenerModuloMasAlto = (programasModulos) => {
  if (Array.isArray(programasModulos) && programasModulos.length > 0) {
    const moduloMasAlto = programasModulos.reduce((max, actual) => {
      return actual.numero > (max.numero ?? -Infinity) ? actual : max;
    }, programasModulos[0]);

    return moduloMasAlto;
  }

  return null;
};

export const imprimirModulo = (programaModulo) => {
  if (!programaModulo) {
    return '-';
  }

  const nombreModulo = programaModulo?.modulo?.nombre;
  const numeroModulo = programaModulo?.numero;

  return `N° ${numeroModulo.toString()} - ${nombreModulo}`;
};

export const formatearFechaYHoraBoliviana = (fecha) => {
  if (!fecha) {
    return '-';
  }

  const parametos = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
  };

  return new Date(fecha).toLocaleString('es-BO', parametos);
};

export const obtenerUrlAPIPagos = (uri) => {
  return `${process.env.VUE_APP_URL_API_PAGOS}${uri}`;
};
